class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    this.cartNotification.setActiveElement(document.activeElement);
    
    const submitButton = this.querySelector('[type="submit"]');
  
    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');
    
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
  
    const formData = new FormData(this.form);
    if (this.cartNotification) {
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      this.cartNotification.setActiveElement(document.activeElement);
    }
    config.body = formData;
  
    fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((parsedState) => {
      this.cartNotification.renderContents(parsedState);
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('disabled');
    });
  }
}

customElements.define('product-form', ProductForm);
